/**
 * Bundle Widget — compact "Complete Your System" radio-group widget.
 * Handles price recalculation and AJAX cart add for the in-form widget.
 */
(function () {
  'use strict';

  function formatMoney(cents) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
    }).format(cents / 100);
  }

  function recalcTotal() {
    var btn = document.getElementById('bw-add-btn');
    if (!btn) return;

    var condenserPrice = parseInt(btn.dataset.condenserPrice || '0', 10);
    var total = condenserPrice;

    document.querySelectorAll('.bw-radio:checked').forEach(function (radio) {
      if (radio.value && radio.dataset.callForPrice !== 'true') {
        total += parseInt(radio.dataset.price || '0', 10);
      }
    });

    var totalEl = document.getElementById('bw-total');
    if (totalEl) totalEl.textContent = formatMoney(total);
  }

  async function addToCart() {
    var btn = document.getElementById('bw-add-btn');
    var btnText = document.getElementById('bw-btn-text');
    if (!btn) return;

    var items = [];

    // Always include the condenser (current product)
    var condenserVariantId = parseInt(btn.dataset.condenserVariantId, 10);
    if (condenserVariantId) {
      items.push({ id: condenserVariantId, quantity: 1 });
    }

    // Include each selected component (skip "none" selections and call-for-price)
    document.querySelectorAll('.bw-radio:checked').forEach(function (radio) {
      if (radio.value && radio.dataset.callForPrice !== 'true') {
        items.push({ id: parseInt(radio.value, 10), quantity: 1 });
      }
    });

    if (items.length === 0) return;

    btn.disabled = true;
    if (btnText) btnText.textContent = 'Adding\u2026';

    try {
      var res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({ items: items }),
      });

      if (!res.ok) throw new Error('Cart add failed');

      if (btnText) btnText.textContent = 'Added \u2713';
      setTimeout(function () {
        window.location.href = '/cart';
      }, 600);
    } catch (err) {
      if (btnText) btnText.textContent = 'Error \u2014 try again';
      setTimeout(function () {
        if (btnText) btnText.textContent = 'Add System to Cart';
        btn.disabled = false;
      }, 2500);
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    var widget = document.getElementById('bundle-widget');
    if (!widget) return;

    // Recalc on any radio change
    widget.querySelectorAll('.bw-radio').forEach(function (radio) {
      radio.addEventListener('change', recalcTotal);
    });

    // Add to cart button
    var addBtn = document.getElementById('bw-add-btn');
    if (addBtn) addBtn.addEventListener('click', addToCart);

    // Rotate chevron with details open/close
    var details = widget.querySelector('details');
    var chevron = widget.querySelector('.bw-chevron');
    if (details && chevron) {
      details.addEventListener('toggle', function () {
        chevron.style.transform = details.open ? 'rotate(180deg)' : '';
      });
      // Set initial state since details starts open
      chevron.style.transform = 'rotate(180deg)';
    }

    // Initial total calculation
    recalcTotal();
  });
})();
